import React from 'react';
import cubesImg from '../../assets/images/publishing-cubes.png';
import {
  PageWrapper,
  PageHeader,
  PageTitleBlock,
  PageTitle,
  PageSubtitle,
  Card,
  CardInner,
  IllustrationWrapper,
  Illustration,
  ContentBlock,
  ProgressBlock,
  ProgressHeading,
  ProgressBarRow,
  ProgressBarFill,
  ProgressPercent,
  ProgressBody,
} from './PublishingProgress.styles';

const DEFAULT_MESSAGE = 'Mapped files are currently being published to reports';

interface IPublishingProgressProps {
  title: string;
  subtitle: string;
  progress: number;
  onCancel?: () => void;
  message?: string;
  showBody?: boolean;
}

export const PublishingProgress: React.FC<IPublishingProgressProps> = ({
  title,
  subtitle,
  progress,
  message = DEFAULT_MESSAGE,
  showBody = true,
}) => {
  return (
    <PageWrapper>
      <PageHeader>
        <PageTitleBlock>
          <PageTitle>{title}</PageTitle>
          <PageSubtitle>{subtitle}</PageSubtitle>
        </PageTitleBlock>
      </PageHeader>
      <Card>
        <CardInner>
          <IllustrationWrapper>
            <Illustration src={cubesImg} alt="" />
          </IllustrationWrapper>
          <ContentBlock>
            <ProgressBlock>
              <ProgressHeading>{message}</ProgressHeading>
              <ProgressBarRow>
                <ProgressBarFill progress={progress} />
              </ProgressBarRow>
              <ProgressPercent>{progress}% completed</ProgressPercent>
            </ProgressBlock>
            {showBody && (
              <ProgressBody>
                <p>
                  Your reports will keep working as usual while the update runs,
                  and will refresh automatically once it&apos;s done.
                </p>
                <p>
                  If you&apos;ve already shared any reports, you&apos;ll need to
                  share them again so others can see the updated data.
                </p>
                <p>
                  If something goes wrong, your reports will still show the
                  previous data.
                  <br />
                  You can fix the issue and try publishing again.
                </p>
              </ProgressBody>
            )}
          </ContentBlock>
        </CardInner>
      </Card>
    </PageWrapper>
  );
};

export default PublishingProgress;
